import { palette } from '@client/theme/colors';
import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Badge' {
  interface BadgePropsVariantOverrides {
    inline: true;
  }
}

const Badge: ThemeOptions['components'] = {
  MuiBadge: {
    defaultProps: {
      color: 'info',
    },
    styleOverrides: {
      root: {},
      badge: {
        color: palette.grey[50],
        fontWeight: 600,
      },
      /*
      https://github.com/mui/material-ui/issues/32699
      colorInfo: {
        backgroundColor: palette.info.dark,
      },
      */
      dot: {
        borderRadius: '50% !important',
      },
      standard: {
        top: '10px !important',
        left: theme.spacing(1.5 * -1),
        height: '21px !important',
        minWidth: '28px !important',
        borderRadius: 12,
        position: 'relative !important' as any,
      },
    },
    variants: [
      {
        props: { variant: 'inline' },
        style: {
          '& > span': {
            left: theme.spacing(2 * -1),
            height: '21px !important',
            minWidth: '28px !important',
            borderRadius: 12,
            padding: '1px 6px !important',
          },
        },
      },
    ],
  },
};

export default Badge;
